import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { dataURLtoFile } from "utils/dataURLToFile";
import { headApi } from "utils/headApi";
import { imgApi } from "utils/imgApi";
import { localApi, localApiImg } from "utils/imgApi";
import { getStates, getCities } from "utils/util";
import { makeStyles } from "@material-ui/core/styles";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import { FaEdit } from "react-icons/fa";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Check from "@material-ui/icons/Check";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardAvatar from "components/Card/CardAvatar.js";
import defaultAvatar from "assets/img/placeholder.jpg";
import defaultImage from "assets/img/image_placeholder.jpg";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import SweetAlert from "react-bootstrap-sweetalert";
import style from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import styleCheck from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";
import styDrop from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";

import { credentials } from "utils/imgApi";

const useStyles = makeStyles(styles);
const useStyle = makeStyles(styleCheck);
const useStyl = makeStyles(styDrop);
const useStylSweet = makeStyles(style);

export default function UpdateBankDetails(props) {
  const [bankName, setBankName] = React.useState("");
  const [bankNameErr, setBankNameErr] = React.useState("");
  const [bankBranch, setBankBranch] = React.useState("");
  const [bankBranchErr, setBankBranchErr] = React.useState("");
  const [bankAddress, setBankAddress] = React.useState("");

  const [ifscCode, setIfscCode] = React.useState("");
  const [ifscCodeErr, setIfscCodeErr] = React.useState("");
  const [shiftCode, setShiftCode] = React.useState("");
  const [upiId, setUpiId] = React.useState("");

  const [accountType, setAccountType] = React.useState("");
  const [accountTypeErr, setAccountTypeErr] = React.useState("");
  const [accountName, setAccountName] = React.useState("");
  const [accountNameErr, setAccountNameErr] = React.useState("");
  const [accountNumber, setAccountNumber] = React.useState("");
  const [accountNumberErr, setAccountNumberErr] = React.useState("");

  const [bank, setBank] = React.useState("");

  const [firstname, setFristname] = React.useState("");
  const [lastname, setLastname] = React.useState("");
  const [proImg, setProImg] = React.useState("");

  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [submittedSign, setSubmittedSign] = React.useState(false);
  const [btn, setBtn] = React.useState(false);

  const classes = useStyles();
  const classCheck = useStyle();
  const classe = useStyl();
  const classSweet = useStylSweet();

  let userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  const [file, setFile] = React.useState(null);
  const [crop, setCrop] = React.useState({
    aspect: 0.833,
    unit: "px",
    width: 280, //280
    height: 336, //336
  });
  const [image, setImage] = React.useState("");
  const [result, setResult] = React.useState("");
  const [imagePreviewUrl, setImagePreviewUrl] = React.useState(
    props.avatar ? defaultAvatar : defaultImage
  );
  let fileInput = React.createRef();

  const handleImageChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      setFile(file);
      setImagePreviewUrl(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const getCroppedImg = () => {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    const base64Image = canvas.toDataURL("image/jpeg");
    setResult(base64Image);
  };

  const handleClick = () => {
    fileInput.current.click();
  };
  const handleRemove = () => {
    setFile(null);
    setImagePreviewUrl(props.avatar ? defaultAvatar : defaultImage);
    fileInput.current.value = null;
  };
  let { avatar, addButtonProps, changeButtonProps, removeButtonProps } = props;

  // eslint-disable-next-line
  const handleSubmit = async (e) => {
    e.preventDefault();
    const apiBank = localApi + `/bankdetails/list/byAdminId/${userObj.id}`;
    const resultBank = await fetch(apiBank, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResultBank = await resultBank.json();

    let fData = new FormData();
    fData.append("qrImage", file || new File([""], ""));
    Axios.put(
      localApi + `/bankdetails/update/qr/findById/${getResultBank[0].id}`,
      fData,
      {
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      }
    ).then((data) => {
      // console.log(data.data);
      if (data.data.message === "Data Updated Successfully !!!") {
        alertTypeOps("success");
        alertMsgOps("Succesfully !!!");
        setSubmittedSign(true);
      }
      // window.location.reload(false);
    });
    // file is the file/image uploaded
    // in this function you can save the image (file) on form submit
    // you have to call it yourself
  };

  async function getUsers() {
    const api = localApi + `/admin/byMobile/${userObj.mobile}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    // setUserEdit(getResult);
    setFristname(getResult.firstname);
    setLastname(getResult.lastname);

    const apiBank = localApi + `/bankdetails/list/byAdminId/${userObj.id}`;
    const resultBank = await fetch(apiBank, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResultBank = await resultBank.json();
    // console.log(getResultBank[0]);
    setBank(getResultBank[0])

    setBankName(getResultBank[0].bankName);
    setBankBranch(getResultBank[0].bankBranch);
    setBankAddress(getResultBank[0].bankAddress);
    setIfscCode(getResultBank[0].ifscCode);
    setShiftCode(getResultBank[0].shiftCode);
    setUpiId(getResultBank[0].upiId);
    setAccountType(getResultBank[0].accountType);
    setAccountName(getResultBank[0].accountName);
    setAccountNumber(getResultBank[0].accountNumber);
    setProImg(getResultBank[0].qrUrl);
  }

  useEffect(() => {
    getUsers();
  }, []);

  const SubmitUpdateBank = (event) => {
    let errorCount = 0;
    if (bankName === "" || !bankName) {
      errorCount++;
      setBankNameErr("Bank Name is Required");
    }
    if (bankBranch === "" || !bankBranch) {
      errorCount++;
      setBankBranchErr("Branch Name is Required");
    }
    if (ifscCode === "" || !ifscCode) {
      errorCount++;
      setIfscCodeErr("IFSC Code is Required");
    }
    if (accountType === "" || !accountType) {
      errorCount++;
      setAccountTypeErr("Account Type is Required");
    }
    if (accountName === "" || !accountName) {
      errorCount++;
      setAccountNameErr("Account Name is Required");
    }
    if (accountNumber === "" || !accountNumber) {
      errorCount++;
      setAccountNumberErr("Account Number is Required");
    }
    if (errorCount === 0) {
      setBtn(true);
      const requestOptions = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Basic ${credentials}`,
        },
        body: JSON.stringify({
          bankName: bankName,
          bankAddress: bankAddress ? bankAddress : null,
          bankBranch: bankBranch,
          ifscCode: ifscCode,
          shiftCode: shiftCode ? shiftCode : null,
          accountType: accountType,
          accountName: accountName,
          accountNumber: accountNumber,
          upiId: upiId ? upiId : null,
        }),
      };
      fetch(localApi + `/bankdetails/update/byId/${bank.id}`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
          if (data.message === "Data Updated Successfully !!!") {
            alertTypeOps("success");
            alertMsgOps("Succesfully !!!");
            setSubmitted(true);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const hideAlert = () => {
    setSubmitted(false);
    setSubmittedSign(false);
    window.location.reload(false);
  };

  const mystyle = {
    paddingLeft: 12,
    flex: 1,
  };

  return (
    <div>
      {file ? (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <FaEdit />
                </CardIcon>
                <h3 className={classes.cardIconTitle}>
                  <small>Add Bank Details</small>
                </h3>
              </CardHeader>
              <CardBody>
                <form>
                  {submitted ? (
                    <SweetAlert
                      type={alertType}
                      style={{ display: "block", marginTop: "-100px" }}
                      title={alertMsg}
                      onConfirm={() => hideAlert()}
                      confirmBtnCssClass={
                        classSweet.button + " " + classSweet.success
                      }
                    >
                      Add Bank Details
                    </SweetAlert>
                  ) : null}
                  {submittedSign ? (
                    <SweetAlert
                      type={alertType}
                      style={{ display: "block", marginTop: "-100px" }}
                      title={alertMsg}
                      onConfirm={() => hideAlert()}
                      confirmBtnCssClass={
                        classSweet.button + " " + classSweet.success
                      }
                    >
                      Updated QR Code Image
                    </SweetAlert>
                  ) : null}
                  <GridContainer>
                    {" "}
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="Bank Name"
                        id="bankName"
                        inputProps={{
                          placeholder: "Bank Name...",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="bankName"
                        value={bankName}
                        onChange={(e) => {
                          setBankName(e.target.value);
                          setBankNameErr("");
                        }}
                      />
                      <span style={{ color: "red" }}>{bankNameErr}</span>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="Bank Branch Name"
                        id="bankBranch"
                        inputProps={{
                          placeholder: "Bank Branch Name...",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="bankBranch"
                        value={bankBranch}
                        onChange={(e) => {
                          setBankBranch(e.target.value);
                          setBankBranchErr("");
                        }}
                      />
                      <span style={{ color: "red" }}>{bankBranchErr}</span>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="Account Name..."
                        id="accountName"
                        inputProps={{
                          placeholder: "Account Name...",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="accountName"
                        value={accountName}
                        onChange={(e) => {
                          setAccountName(e.target.value);
                          setAccountNameErr("");
                        }}
                      />
                      <span style={{ color: "red" }}>{accountNameErr}</span>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="Account Number..."
                        id="accountNumber"
                        inputProps={{
                          placeholder: "Account Number...",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="accountNumber"
                        value={accountNumber}
                        onChange={(e) => {
                          setAccountNumber(e.target.value);
                          setAccountNumberErr("");
                        }}
                      />
                      <span style={{ color: "red" }}>{accountNumberErr}</span>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="IFSC Code"
                        id="ifscCode"
                        inputProps={{
                          placeholder: "IFSC Code...",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="ifscCode"
                        value={ifscCode}
                        onChange={(e) => {
                          setIfscCode(e.target.value);
                          setIfscCodeErr("");
                        }}
                      />
                      <span style={{ color: "red" }}>{ifscCodeErr}</span>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="SHIFT/BIC Code"
                        id="shiftCode"
                        inputProps={{
                          placeholder: "SHIFT/BIC Code...",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="shiftCode"
                        value={shiftCode}
                        onChange={(e) => {
                          setShiftCode(e.target.value);
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="UPI Id"
                        id="upiId"
                        inputProps={{
                          placeholder: "UPI Id...",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="upiId"
                        value={upiId}
                        onChange={(e) => {
                          setUpiId(e.target.value);
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="Account Type"
                        id="accountType"
                        inputProps={{
                          placeholder: "Account Type...",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="accountType"
                        value={accountType}
                        onChange={(e) => {
                          setAccountType(e.target.value);
                          setAccountTypeErr("");
                        }}
                      />
                      <span style={{ color: "red" }}>{accountTypeErr}</span>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Bank Address..."
                        id="bankAddress"
                        inputProps={{
                          placeholder: "Bank Address...",
                          multiline: true,
                          rows: 3,
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="bankAddress"
                        value={bankAddress}
                        onChange={(e) => {
                          setBankAddress(e.target.value);
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  {btn === true ? (
                    <Button className={classes.updateProfileButton}>
                      Update
                    </Button>
                  ) : (
                    <Button
                      color="rose"
                      onClick={SubmitUpdateBank}
                      className={classes.updateProfileButton}
                    >
                      Update
                    </Button>
                  )}
                </form>
              </CardBody>
            </Card>
          </GridItem>

          <GridItem xs={12} sm={12} md={12}>
            <Card profile>
              <CardAvatar style={{ marginTop: 20 }}>
                <a href="#pablo" onClick={(e) => e.preventDefault()}>
                  {/* <img src={image ? image : defaultAvatar} alt="..." /> */}
                  <img src={proImg ? proImg : defaultAvatar} alt="..." width="100%" />
                </a>
              </CardAvatar>
              <CardBody profile>
                <h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6>
                <h4 className={classes.cardTitle}>
                  {firstname + "  " + lastname}
                </h4>

                <legend>My QR Code Image*</legend>
                <div className="fileinput text-center">
                  <input
                    type="file"
                    onChange={handleImageChange}
                    ref={fileInput}
                  />

                  {file && (
                    <div
                      className={"thumbnail" + (avatar ? " img-circle" : "")}
                    >
                      <img src={imagePreviewUrl} alt="..." />
                    </div>
                  )}

                  <div>
                    {file === null ? (
                      <Button
                        color="rose"
                        {...addButtonProps}
                        onClick={() => handleClick()}
                      >
                        {avatar ? "Select QR" : "Select QR"}
                      </Button>
                    ) : (
                      <span>
                        <Button
                          color="rose"
                          {...changeButtonProps}
                          onClick={() => handleClick()}
                        >
                          Change
                        </Button>
                        {avatar ? <br /> : null}
                        <Button
                          color="rose"
                          {...removeButtonProps}
                          onClick={() => handleRemove()}
                        >
                          <i className="fas fa-times" /> Remove
                        </Button>
                        <Button color="rose" round onClick={handleSubmit}>
                          upload QR Code
                        </Button>
                      </span>
                    )}
                  </div>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      ) : (
        <GridContainer>
          <GridItem xs={12} sm={8} md={8}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <FaEdit />
                </CardIcon>
                <h3 className={classes.cardIconTitle}>
                  <small>Add Bank Details</small>
                </h3>
              </CardHeader>
              <CardBody>
                <form>
                  {submitted ? (
                    <SweetAlert
                      type={alertType}
                      style={{ display: "block", marginTop: "-100px" }}
                      title={alertMsg}
                      onConfirm={() => hideAlert()}
                      confirmBtnCssClass={
                        classSweet.button + " " + classSweet.success
                      }
                    />
                  ) : null}
                  <GridContainer>
                    {" "}
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="Bank Name"
                        id="bankName"
                        inputProps={{
                          placeholder: "Bank Name...",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="bankName"
                        value={bankName}
                        onChange={(e) => {
                          setBankName(e.target.value);
                          setBankNameErr("");
                        }}
                      />
                      <span style={{ color: "red" }}>{bankNameErr}</span>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="Bank Branch Name"
                        id="bankBranch"
                        inputProps={{
                          placeholder: "Bank Branch Name...",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="bankBranch"
                        value={bankBranch}
                        onChange={(e) => {
                          setBankBranch(e.target.value);
                          setBankBranchErr("");
                        }}
                      />
                      <span style={{ color: "red" }}>{bankBranchErr}</span>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="Account Name..."
                        id="accountName"
                        inputProps={{
                          placeholder: "Account Name...",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="accountName"
                        value={accountName}
                        onChange={(e) => {
                          setAccountName(e.target.value);
                          setAccountNameErr("");
                        }}
                      />
                      <span style={{ color: "red" }}>{accountNameErr}</span>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="Account Number..."
                        id="accountNumber"
                        inputProps={{
                          placeholder: "Account Number...",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="accountNumber"
                        value={accountNumber}
                        onChange={(e) => {
                          setAccountNumber(e.target.value);
                          setAccountNumberErr("");
                        }}
                      />
                      <span style={{ color: "red" }}>{accountNumberErr}</span>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="IFSC Code"
                        id="ifscCode"
                        inputProps={{
                          placeholder: "IFSC Code...",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="ifscCode"
                        value={ifscCode}
                        onChange={(e) => {
                          setIfscCode(e.target.value);
                          setIfscCodeErr("");
                        }}
                      />
                      <span style={{ color: "red" }}>{ifscCodeErr}</span>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="SHIFT/BIC Code"
                        id="shiftCode"
                        inputProps={{
                          placeholder: "SHIFT/BIC Code...",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="shiftCode"
                        value={shiftCode}
                        onChange={(e) => {
                          setShiftCode(e.target.value);
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="UPI Id"
                        id="upiId"
                        inputProps={{
                          placeholder: "UPI Id...",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="upiId"
                        value={upiId}
                        onChange={(e) => {
                          setUpiId(e.target.value);
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="Account Type"
                        id="accountType"
                        inputProps={{
                          placeholder: "Account Type...",
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="accountType"
                        value={accountType}
                        onChange={(e) => {
                          setAccountType(e.target.value);
                          setAccountTypeErr("");
                        }}
                      />
                      <span style={{ color: "red" }}>{accountTypeErr}</span>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Bank Address..."
                        id="bankAddress"
                        inputProps={{
                          placeholder: "Bank Address...",
                          multiline: true,
                          rows: 3,
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="bankAddress"
                        value={bankAddress}
                        onChange={(e) => {
                          setBankAddress(e.target.value);
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  {btn === true ? (
                    <Button className={classes.updateProfileButton}>
                      Update
                    </Button>
                  ) : (
                    <Button
                      color="rose"
                      onClick={SubmitUpdateBank}
                      className={classes.updateProfileButton}
                    >
                      Update
                    </Button>
                  )}
                </form>
              </CardBody>
            </Card>
          </GridItem>

          <GridItem xs={12} sm={4} md={4}>
            <Card profile>
              <CardAvatar style={{ marginTop: 20 }}>
                <a href="#pablo" onClick={(e) => e.preventDefault()}>
                  {/* <img src={image ? image : defaultAvatar} alt="..." /> */}
                  <img src={proImg ? proImg : defaultAvatar} alt="..." width="100%" />
                </a>
              </CardAvatar>
              <CardBody profile>
                <h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6>
                <h4 className={classes.cardTitle}>
                  {firstname + "  " + lastname}
                </h4>

                <legend>My QR Code Image*</legend>

                <div className="fileinput text-center">
                  <input
                    type="file"
                    onChange={handleImageChange}
                    ref={fileInput}
                  />

                  {file && (
                    <div
                      className={"thumbnail" + (avatar ? " img-circle" : "")}
                    >
                      <img src={imagePreviewUrl} alt="..." />
                    </div>
                  )}

                  <div>
                    {file === null ? (
                      <Button
                        color="rose"
                        {...addButtonProps}
                        onClick={() => handleClick()}
                      >
                        {avatar ? "Select QR" : "Select QR"}
                      </Button>
                    ) : (
                      <span>
                        <Button
                          color="rose"
                          {...changeButtonProps}
                          onClick={() => handleClick()}
                        >
                          Change
                        </Button>
                        {avatar ? <br /> : null}
                        <Button
                          color="rose"
                          {...removeButtonProps}
                          onClick={() => handleRemove()}
                        >
                          <i className="fas fa-times" /> Remove
                        </Button>
                        <Button color="rose" round onClick={handleSubmit}>
                          upload QR Code
                        </Button>
                      </span>
                    )}
                  </div>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      )}
    </div>
  );
}

UpdateBankDetails.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
};
